import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ErrorIcon from '@mui/icons-material/Error';
import HouseIcon from '@mui/icons-material/House';

import { RunTaskStatuses, RunTaskTypes, localeTimeFormat } from '../../../lib/utils';

const styles = {
  runTaskContainer: {
    display: 'flex',
    marginBottom: '12px',
  },
  header: {
    fontSize: '12px',
    fontWeight: '600',
  },
  subHeader: {
    fontSize: '10px',
    color: 'grey',
    height: '20px',
  },
  icon: {
    marginTop: '8px',
    fontSize: '18px',
  },
  headerContainer: {
    marginLeft: '8px',
  },
  time: {
    fontSize: '10px',
    marginLeft: 'auto',
  },
};

function BaseRunTask({
  tz, runTask,
}) {
  const runTaskTypeToText = {
    [RunTaskTypes.PICKUP]: 'Pick Up',
    [RunTaskTypes.DEPLOY]: 'Drop Off',
    [RunTaskTypes.INACCESSIBLE]: 'Reported Inaccessible',
    [RunTaskTypes.MISSING]: 'Reported Missing',
    [RunTaskTypes.DAMAGED]: 'Reported Damaged',
  };

  const runTaskText = () => {
    let text = runTaskTypeToText[runTask.type];
    if (runTask.status === RunTaskStatuses.ATTEMPTED) {
      text = runTask.attemptFailedReason;
    }
    if (runTask.vehicle) {
      text += ` ${runTask.vehicle.humanId}`;
    }
    return text;
  };

  const subHeaderText = () => {
    if (runTask.type === RunTaskTypes.DEPLOY) {
      if (runTask.location) {
        let text = runTask.location.name;
        if (runTask.status === RunTaskStatuses.COMPLETED && runTask.deployOrder) {
          text += ` (${runTask.deployOrder}/${runTask.recommendedDeploysForLocation})`;
        }
        return text;
      }
    } else if (runTask.pickupReasons && runTask.pickupReasons.length > 0) {
      let text = '';
      for (const reason of runTask.pickupReasons) {
        text += ` ${reason},`;
      }
      return text.slice(0, -1);
    }
  };

  const icon = () => {
    if (runTask.isWarehouse) {
      return <HouseIcon style={{ ...styles.icon, color: '#1976D2' }} />;
    } else if (runTask.status === RunTaskStatuses.COMPLETED && runTask.isRecommended) {
      return <CheckCircleIcon style={{ ...styles.icon, color: '#4CAF50' }} />;
    } else if (runTask.status === RunTaskStatuses.COMPLETED
      && !runTask.isRecommended || runTask.status === RunTaskStatuses.ATTEMPTED) {
      return <ErrorIcon style={{ ...styles.icon, color: '#FF9800' }} />;
    } else {
      return <CancelIcon style={{ ...styles.icon, color: '#EF5350' }} />;
    }
  };

  return (
    <div style={styles.runTaskContainer}>
      {icon()}
      <div style={styles.headerContainer}>
        <Typography style={styles.header}>
          {runTask.isWarehouse ? runTask.location.name : runTaskText()}
        </Typography>
        <Typography style={styles.subHeader}>
          {runTask.isWarehouse ? runTask.timeDiff : subHeaderText()}
        </Typography>
      </div>
      <Typography style={styles.time}>
        {runTask.completedAt && ` ${moment.tz(runTask.completedAt, tz).format(localeTimeFormat)}`}
      </Typography>
    </div>
  );
}

BaseRunTask.defaultProps = {};
BaseRunTask.propTypes = {
  tz: PropTypes.string.isRequired,
  runTask: PropTypes.shape({
    _id: PropTypes.string,
  }).isRequired,
};

const RunTask = withRouter(BaseRunTask);
export { BaseRunTask, RunTask };
